import { push } from 'connected-react-router';
import { toastr } from 'react-redux-toastr';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const SAVE_FORM_REVIEW_STATE_REQUEST = 'SAVE_FORM_REVIEW_STATE_REQUEST';
export const SAVE_FORM_REVIEW_STATE_SUCCESS = 'SAVE_FORM_REVIEW_STATE_SUCCESS';
export const SAVE_FORM_REVIEW_STATE_USER_ASSIGNMENT_SUCCESS = 'SAVE_FORM_REVIEW_STATE_USER_ASSIGNMENT_SUCCESS';
export const SAVE_FORM_REVIEW_STATE_FAILURE = 'SAVE_FORM_REVIEW_STATE_FAILURE';
export const SAVE_FORM_REVIEW_STATE_PARAMETERS = 'SAVE_FORM_REVIEW_STATE_PARAMETERS';

function requestSaveFormReviewState() {
  return {
    type: SAVE_FORM_REVIEW_STATE_REQUEST,
    isSavingFormReviewState: true,
  };
}

function requestSaveFormReviewStateParameters(values) {
  return {
    type: SAVE_FORM_REVIEW_STATE_PARAMETERS,
    formReviewStateParameters: values
  };
}

function receiveSaveFormReviewState(formReviewState) {
  return {
    type: SAVE_FORM_REVIEW_STATE_SUCCESS,
    isSavingFormReviewState: false,
    formReviewState,
    formReviewStateError: null
  };
}

function receiveSaveFormReviewStateWithUserAssignment(formReviewState) {
  return {
    type: SAVE_FORM_REVIEW_STATE_USER_ASSIGNMENT_SUCCESS,
    isSavingFormReviewState: false,
    formReviewState,
    formReviewStateError: null
  };
}

function rejectSaveFormReviewState(formReviewStateError) {
  return {
    type: SAVE_FORM_REVIEW_STATE_FAILURE,
    isSavingFormReviewState: false,
    formReviewStateError
  };
}

export function saveFormReviewState(formId, values, preventRedirect) {
  const formData = new FormData();
  let assignedUser = false;
  formData.append('actionId', values.actionId);
  if (values.assignToUser) {
    formData.append('assignToUser', values.assignToUser.id);
    assignedUser = true;
  }
  formData.append('isKycReviewed', values.isKycReviewed);

  return (dispatch) => {
    dispatch(requestSaveFormReviewState());

    const promise = () => ApiService
      .saveFormReviewState(formId, formData)
      .then((response) => {
        if (assignedUser) {
          dispatch(receiveSaveFormReviewStateWithUserAssignment(response.data));
        } else {
          dispatch(receiveSaveFormReviewState(response.data));
        }

        if (values.actionId && !preventRedirect) {
          // Redirect home if a workflow action has been submitted
          dispatch(push('/'));
        } else {
          toastr.success(`${ assignedUser ? 'Review successfully saved and form assigned to another user at the current workflow stage.' : 'Review successfully saved.' }`);
        }
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectSaveFormReviewState, true));
        }
      });
    return promise();
  };
}

export function saveFormReviewStateParameters(values) {
  return (dispatch) => {
    dispatch(requestSaveFormReviewStateParameters(values));
  };
}
